import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import { Box, TextField, Button, InputAdornment, Typography } from '@material-ui/core';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import Icon from 'sharedComponents/Icon';
import { initialValues, validationSchema } from 'forms/loanOfficerRegistrationForm';

import useStyles from './useStyles';

const LoanOfficerRegistrationForm = props => {
  const { t } = useTranslation();
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const classes = useStyles();

  const { onSubmit } = props;

  const formik = useFormik({
    validationSchema,
    initialValues,
    onSubmit,
  });

  const { errors, values, handleChange, handleBlur, touched, handleSubmit } = formik;

  const isAbleToSubmit = isEmpty(errors);

  const handleClickShowPassword = () => setPasswordVisible(!isPasswordVisible);
  return (
    <Box className={classes.paper}>
      <form className={classes.form} onSubmit={handleSubmit}>
        <TextField
          error={touched.firstName && (Boolean(errors.firstName) || Boolean(errors.serverError))}
          helperText={touched.firstName && t(errors.firstName)}
          variant="outlined"
          id="firstName"
          name="firstName"
          type="firstName"
          placeholder={t('components.LoanOfficerRegistrationForm.firstName')}
          autoComplete="firstName"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.firstName}
          className={classes.field}
        />
        <TextField
          error={touched.lastName && (Boolean(errors.lastName) || Boolean(errors.serverError))}
          helperText={touched.lastName && t(errors.lastName)}
          variant="outlined"
          id="lastName"
          name="lastName"
          type="lastName"
          placeholder={t('components.LoanOfficerRegistrationForm.lastName')}
          autoComplete="lastName"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.lastName}
          className={classes.field}
        />
        <TextField
          error={touched.email && (Boolean(errors.email) || Boolean(errors.serverError))}
          helperText={touched.email && t(errors.email)}
          variant="outlined"
          id="email"
          name="email"
          type="email"
          placeholder={t('components.LoanOfficerRegistrationForm.email')}
          autoComplete="email"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.email}
          className={classes.field}
        />
        <TextField
          error={touched.nmls && (Boolean(errors.nmls) || Boolean(errors.serverError))}
          helperText={touched.nmls && t(errors.nmls)}
          variant="outlined"
          id="nmls"
          name="nmls"
          type="nmls"
          placeholder={t('components.LoanOfficerRegistrationForm.nmls')}
          autoComplete="nmls"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.nmls}
          className={classes.field}
        />
        <TextField
          error={touched.password && (Boolean(errors.password) || Boolean(errors.serverError))}
          helperText={touched.password && t(errors.password)}
          variant="outlined"
          name="password"
          type={isPasswordVisible ? 'text' : 'password'}
          id="password"
          placeholder={t('components.LoanOfficerRegistrationForm.password')}
          autoComplete="new-password"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
          className={classes.field}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {isPasswordVisible ? (
                  <Icon name="visible" onClick={handleClickShowPassword} className={classes.visibilityIcon} />
                ) : (
                  <Icon name="visibleOff" onClick={handleClickShowPassword} className={classes.visibilityIcon} />
                )}
              </InputAdornment>
            ),
          }}
        />
        <TextField
          error={touched.passwordConfirmation && (Boolean(errors.passwordConfirmation) || Boolean(errors.serverError))}
          helperText={(touched.passwordConfirmation && t(errors.passwordConfirmation)) || ' '}
          variant="outlined"
          name="passwordConfirmation"
          placeholder={t('components.LoanOfficerRegistrationForm.confirmPassword')}
          type={isPasswordVisible ? 'text' : 'password'}
          id="passwordConfirmation"
          autoComplete="new-password"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.passwordConfirmation}
          className={classes.field}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {isPasswordVisible ? (
                  <Icon name="visible" onClick={handleClickShowPassword} className={classes.visibilityIcon} />
                ) : (
                  <Icon name="visibleOff" onClick={handleClickShowPassword} className={classes.visibilityIcon} />
                )}
              </InputAdornment>
            ),
          }}
        />
        {errors.serverError && (
          <Typography className={classes.error} variant="subtitle1" color="error">
            {errors.serverError}
          </Typography>
        )}
        <Button className={classes.button} type="submit" disabled={!isAbleToSubmit}>
          {t('components.LoanOfficerRegistrationForm.button')}
        </Button>
      </form>
    </Box>
  );
};

LoanOfficerRegistrationForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default LoanOfficerRegistrationForm;



// WEBPACK FOOTER //
// ./src/sharedComponents/LoanOfficerRegistrationForm/LoanOfficerRegistrationForm.js